<div class="body-inner" id="Home">
  <!-- Header start -->
  <!-- <app-header></app-header> -->
  <!--/ Header end -->

  <router-outlet></router-outlet>
  <!-- ts footer area start-->
  <!-- <app-footer></app-footer> -->
  <!-- ts footer area end-->
</div>
<!-- Body inner end -->
